<ul class="tree">
  <li>
    <tree-node [folder]="fileExplorerService.rootItem"
               (mouseenter)="fileExplorerService.setHoveredTreeItem(fileExplorerService.rootItem)"
               (mouseleave)="fileExplorerService.clearHoveredTreeItem()"></tree-node>
  </li>
</ul>
